import {
    ConfigInfo,
    CurveInfo,
    ImageInfo,
    MaterialInfo,
    MeshInfo,
    NumberInfo,
    StringInfo,
    TemplateInfo,
    TransformInfo,
    curveLike,
    imageLike,
    materialLike,
    meshLike,
    numberLike,
    NumberExport,
    stringLike,
    templateLike,
    transformLike,
} from "@cm/template-nodes"
import {mattressBaseMesh, mattressCurveLike, mattressReferenceFrameLike} from "#mattress/validation"
import {MattressCurveInfo, MattressReferenceFrameInfo} from "#mattress/nodes/component/mattress-component-interface-descriptors"
import type {MattressInterfaceDescriptor} from "#mattress/nodes/component/mattress-component-interface-descriptors"
import {MattressCurveExport} from "#mattress/nodes/curve/mattress-curve-export"
import {MattressReferenceFrameExport} from "#mattress/nodes/reference-frame/mattress-reference-frame-export"
import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"

export function schemaForDescriptor(descriptor: MattressInterfaceDescriptor, allowExports = false) {
    if (descriptor instanceof MattressCurveInfo)
        return z.nullable(allowExports ? z.union([mattressCurveLike, graphNode(MattressCurveExport)]) : mattressCurveLike)
    else if (descriptor instanceof MattressReferenceFrameInfo)
        return z.nullable(allowExports ? z.union([mattressReferenceFrameLike, graphNode(MattressReferenceFrameExport)]) : mattressReferenceFrameLike)
    else if (descriptor instanceof NumberInfo) return z.nullable(allowExports ? z.union([numberLike, graphNode(NumberExport)]) : numberLike)
    else if (descriptor instanceof MaterialInfo) return z.nullable(materialLike)
    else if (descriptor instanceof CurveInfo) return z.nullable(z.union([mattressCurveLike, curveLike]))
    else if (descriptor instanceof TemplateInfo) return z.nullable(templateLike)
    else if (descriptor instanceof ImageInfo) return z.nullable(imageLike)
    else if (descriptor instanceof MeshInfo) return z.nullable(z.union([meshLike, mattressBaseMesh]))
    else if (descriptor instanceof StringInfo) return z.nullable(stringLike)
    else if (descriptor instanceof ConfigInfo) return z.optional(stringLike)
    else if (descriptor instanceof TransformInfo) return z.nullable(transformLike)
    else throw new Error("Unsupported descriptor")
}
